// Pool unrounded goals on identical fixtures; never average individual quotients.
export const comparisonPair = (g, source) => {
  const p = source === "real" ? g.goals : source === "should" ? g.should
    : source === "xgoals" ? (g.external_xgoals?.kind === "should_goals_substitute" ? null : g.external_xgoals)
    : source === "result" ? g.result?.xg : source === "statistics" ? g.statistics_model?.xg
    : g.market?.quality === "verified" ? g.market.xg : null;
  return p && [p.home,p.away].every(v => typeof v === "number" && Number.isFinite(v) && v >= 0) ? p : null;
};
export function comparisonGames(games, teamId, before, limit = null) {
  const cutoff = Date.parse(before);
  const selected = games.filter(g => g.final && Date.parse(g.kickoff) < cutoff &&
    [g.home_team_id,g.away_team_id].map(Number).includes(Number(teamId)))
    .sort((a,b) => Date.parse(b.kickoff)-Date.parse(a.kickoff) || Number(b.id)-Number(a.id));
  return limit === null ? selected : selected.slice(0,limit);
}
export function comparisonValue(games, teamId, source, field, absolute = false) {
  const venue = field.endsWith("_home") ? "home" : field.endsWith("_away") ? "away" : null;
  const selected = games.filter(g => !venue || Number(g[venue+"_team_id"]) === Number(teamId));
  const valid = selected.filter(g => comparisonPair(g,source));
  let own=0,against=0;
  for (const g of valid) { const p=comparisonPair(g,source), home=Number(g.home_team_id)===Number(teamId); own+=home?p.home:p.away; against+=home?p.away:p.home; }
  const n=valid.length;
  const value=!n ? null : field === "total_strength" ? (against>0?own/against:null)
    : field.startsWith("total_goals") ? (own+against)/(absolute?1:n) : (field.startsWith("against")?against:own)/(absolute?1:n);
  return {value,count:n,selected:selected.length,ids:valid.map(g=>g.id)};
}
export function comparisonDirection(games, teamId, source, field) {
  if (["result","statistics"].includes(source)) return [];
  return ["result","statistics"].map(model=>{
    const matched=games.filter(g=>comparisonPair(g,source)&&comparisonPair(g,model));
    const observed=comparisonValue(matched,teamId,source,field);
    const expected=comparisonValue(matched,teamId,model,field);
    const delta=observed.value == null || expected.value == null ? null : observed.value-expected.value;
    return {model,...observed,expected:expected.value,delta,favorable:delta == null || field.startsWith("total_goals") ? null : (field.startsWith("against")?-delta:delta)};
  });
}

// Focus is a navigation aid, never a verdict on a bet.
export function comparisonFocus(field, side, selection, manual = "tip") {
 const focus = manual !== "tip" ? manual : ["over","under"].includes(selection) ? "goals" : ["X","12"].includes(selection) ? "draw" : "side";
 if(focus === "all") return 1;
 if(focus === "goals") return field === `total_goals_${side}` ? 2 : field === "total_goals" ? 1 : 0;
 if(focus === "strength") return field === "total_strength" ? 1 : 0;
 if(focus === "draw") return ["total_strength","total_goals","drawfactor"].includes(field) ? 1 : 0;
 return field === "total_strength" && focus === "side" ? 1 : [`for_${side}`,`against_${side}`].includes(field) ? 1 : 0;
}
export function comparisonSummaryValue(summary, field) {
 if (!summary) return null;
 if (["total_goals_home","total_goals_away"].includes(field)) {
  const side=field.endsWith("home")?"home":"away", a=summary[`for_${side}`], b=summary[`against_${side}`];
  return typeof a === "number" && typeof b === "number" ? a+b : null;
 }
 return summary[field];
}
